import React from "react";
import { Outlet } from "react-router-dom";

import useFullScreenLoading from "../../../hooks/useFullScreenLoading";

type Props = {};

export default function ServiceCallback({}: Props) {
  const loadingComponent = useFullScreenLoading({ isLoading: true });

  return (
    <div>
      {loadingComponent}
      <Outlet />
    </div>
  );
}
